export const generateUUID = () => {
  // cut the mustard for the easy way to generate a UUID
  if ('randomUUID' in crypto) {
    return crypto.randomUUID();
  }

  // generate a UUID in a more supported way: https://stackoverflow.com/a/2117523
  // eslint-disable-next-line
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
};
